<div class="loading-overlay" [ngClass]="isPage ? 'page-loader':''">
  <div class="spacer"></div>
  <div class="loader">
    <i class="fa fa-spinner" aria-hidden="true"></i>
  </div>
  <div class="spacer"></div>
</div>
